const LabTestDescriptionConfig = [
    { span: 8, height: "220px", classes: "marginTop-24" },
    { span: 6, height: "24px", classes: "marginTop-16" },
    { span: 7, height: "24px", classes: "marginTop-16" },
    { span: 8, height: "24px", classes: "marginTop-16" },
    { span: 8, height: "200px", classes: "marginTop-16" },
]
export default LabTestDescriptionConfig
